import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon, GiftIcon } from 'lucide-react';
const bonuses = ['Manual Profesional para Gestionar el Estrés Cotidiano', 'Dependencia Emocional: Cómo Construir Relaciones Sanas', 'Los 100 Errores que Destruyen tu Autoestima', 'Hábitos para una Mente Fuerte', 'Comunicación Asertiva y Límites Saludables'];
export function Bonuses() {
  return <section className="bg-rose/45 px-4 py-20 md:py-28" data-id="element-12" data-mp="1un7tz5q0q3o">
      <div className="mx-auto max-w-5xl" data-id="element-13" data-mp="1t3r67g5kd1d">
        <div className="mx-auto max-w-2xl text-center" data-id="element-14" data-mp="5wi5mtog0lcp">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-clay text-white" data-id="element-15" data-mp="5tvy2u1jy5uh">
            <GiftIcon className="h-6 w-6" aria-hidden="true" data-id="element-16" data-mp="3o3y4dotj4w60" />
          </div>
          <p className="mt-5 text-sm font-bold uppercase tracking-[0.15em] text-clay-dark" data-id="element-17" data-mp="3t0ycs6duqb0a">Material complementario</p>
          <h2 className="mt-3 font-heading text-4xl font-semibold leading-tight text-ink md:text-5xl" data-id="element-18" data-mp="1m8fdzg6hm9t4">
            Además recibís 5 bonos exclusivos
          </h2>
        </div>

        <ol className="mt-12 overflow-hidden rounded-2xl border border-clay/20 bg-white shadow-sm" data-id="element-19" data-mp="3iclm7offscw8">
          {bonuses.map((title, index) => <motion.li key={title} initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.35,
          delay: index * 0.06
        }} className="flex items-center gap-5 border-b border-clay/15 px-5 py-5 last:border-b-0 md:px-8" data-id="element-20" data-mp="3r6qiwoh94ijo" data-mpi={index}>
              <span className="font-heading text-2xl font-semibold text-clay-dark" data-id="element-21" data-mp="38g8ugw3gc944">{String(index + 1).padStart(2, '0')}</span>
              <h3 className="font-heading text-xl font-semibold leading-snug text-ink md:text-2xl" data-id="element-22" data-mp="33gw6u94ray0h">{title}</h3>
            </motion.li>)}
        </ol>

        <div className="mt-12 text-center" data-id="element-23" data-mp="ns4c4e8migbx">
          <a href="#temario" className="inline-flex items-center gap-2 rounded-full bg-ink px-7 py-4 text-sm font-bold uppercase tracking-[0.06em] text-white transition-colors hover:bg-clay-dark" data-id="element-24" data-mp="irgcx5a8qt6m">
            Conocé la formación completa
            <ArrowDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-25" data-mp="3hgg7rw96q8e9" />
          </a>
          <p className="mt-3 text-xs text-ink/55" data-id="element-26" data-mp="3lkw9rmfogvo7">Acceso inmediato luego de completar tu compra.</p>
        </div>
      </div>
    </section>;
}